import React, { useRef } from "react";
import { useSelector } from "react-redux";

import { useDialogState } from "../../../hooks/useDialogState";
import MaterialTable from "@material-table/core";
import {confirmWrapper} from "../../../shared/confirm";
import BimProfileService from "../../../services/BimProfileService";
import BimCreate from "./BimCreate";
import UserService from "../../../services/UserService";
import { header } from'../../../shared/headerStyle';

const TOOLBAR_HEIGHT = 74;
const COLUMN_HEADER = 40;
const PAGINATION_HEIGHT = 52;
const PADDING = 0;

function ProfilesListView({ profileList, GetProfilesData, setBimProfileSelected, bimProfileSelected, addNew, showBimetaProfiles }) {
    const tableRef = useRef();
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const dialog = useDialogState();
    const setBIMDialogOpen = dialog.setBimOpen;

    const tableHeight = `calc(100vh - ${TOOLBAR_HEIGHT + COLUMN_HEADER + PAGINATION_HEIGHT + PADDING}px)`;

    const handleClickOnRow = (profile) => {
        setBimProfileSelected(profile);
        setBIMDialogOpen(true);
    };

    const Profile_Delete = async (profile) => {
        try {
            if (await confirmWrapper('Soll das BimProfil wirklich gelöscht werden?')) {
                await BimProfileService.deleteBimProfile(token, realm, profile);
                await GetProfilesData();
            }
        } catch (e) {
            console.error("Fehler beim Löschen des Profils:", e);
        }
    };

    return (
        <>
            <div style={{ padding: '12px', boxSizing: 'border-box', width: '100%' }}>
            <MaterialTable
                tableRef={tableRef}
                title="Profile"
                columns={[
                    { title: 'Bezeichnung', field: 'name' },
                    { title: 'Beschreibung', field: 'description'},
                    { title: 'deaktiviert', field: 'deactivated', lookup: { 0: 'nein', 1: 'ja' } },
                ]}
                data={profileList}
                options={{
                    headerStyle: header,
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    exportButton: true,
                    exportAllData: true,
                    maxBodyHeight: tableHeight,
                    minBodyHeight: tableHeight,
                }}
                actions={[
                    {
                        icon: 'wysiwyg',
                        tooltip: 'Details',
                        onClick: (event, rowData) => handleClickOnRow(rowData)
                    },
                    {
                        icon: 'delete',
                        tooltip: 'löschen',
                        onClick: (event, rowData) => Profile_Delete(rowData),
                        disabled: (rowData) => {
                            return (rowData.isGeneralProfile && !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN']))
                                || (!rowData.isGeneralProfile && !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN']))
                        }
                    },
                    {
                        icon: 'add',
                        tooltip: 'Neues Profil anlegen',
                        isFreeAction: true,
                        onClick: () => addNew(),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                    },
                    {
                        icon: 'post_add',
                        tooltip: 'Bimeta-Profile anzeigen',
                        isFreeAction: true,
                        onClick: () => showBimetaProfiles(),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_ADMIN'])
                    }
                ]}
                onRowClick={(event, rowData) => handleClickOnRow(rowData)}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: ''
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        },
                        editRow: {
                            deleteText: 'Soll der Datensatz wirklich gelöscht werden?',
                            saveTooltip: 'Speichern',
                            cancelTooltip: 'Abbrechen'
                        }
                    }
                }}
            />
            </div>
            <BimCreate
                bimProfileSelected={bimProfileSelected}
                GetProfilesData={GetProfilesData}
            />
        </>
    );
}

export default ProfilesListView;